import React from 'react';

export default function Spinner() {
  return (
    <div className="lds-spinner">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
}

export const Loader = () => <div className='flex items-center justify-center'>
  <div className="w-4 h-4 border-l-4 border-general-teal rounded-full animate-spin"></div>
</div>